import React from "react";
import { Table, Button } from "reactstrap";
import privateActions from "../../../../API/privateCalls/privateActions";
import { toast } from "react-toastify";
import {getCSVInstitutions} from "../../../../utils/helperMethods";


export default class TablaColegios extends React.Component {

deleteSponsor(e){
  privateActions.QuitarPremium(e.idPublico,e.sponsor.id).then(()=>{
    this.props.onDelete()
    toast.error("Se quitó premium de  " +e.nombre)
  })
}
  render() {
    if (!this.props.data) return null;

    return (
      <Table hover className="mb-0">
        <thead>
          <tr>

            <th className="text-center">Apellido</th>
            <th className="text-center">Nombre</th>
            <th className="text-center">Mail</th>

            <th className="text-center">Localidad</th>
            
            <th className="text-center">Provincia</th>
            <th className="text-center">Pais</th>
           
            <th className="text-center">Telefono</th>

            <th className="text-center">Cantidad de Alumnos</th>
            <th className="text-center">Lista de Escuelas</th>
            <th className="text-center">Cantidad de Escuelas</th>
            <th className="text-center">Cantidad de Aulas creadas</th>

            <th className="text-center">Sponsor</th>
          {/*   <th className="text-center">Usuarios</th> */}

            <th className="text-center">Premium</th>
            

          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>

                <td className="text-center">{e.apellido}</td>
                <td className="text-center">{e.nombre}</td>
                <td className="text-center">{e.usuario}</td>
                <td className="text-center">{e.localidad?e.localidad.nombre:"No Tiene"}</td>
                <td className="text-center">{e.localidad?e.localidad.provincia.nombre:"No Tiene"}</td>
                <td className="text-center">{e.localidad?e.localidad.provincia.pais.nombre:"No Tiene"}</td>
                <td className="text-center">{`(${e.telefonoPrefijo}) ${e.telefonoNumero}`}</td>
                <td className="text-center">{e.countAlumnos?e.countAlumnos:"No tiene"}</td>
                <th className="text-center">{getCSVInstitutions(e.instituciones)}</th>
                <td className="text-center">{e.countInstituciones?e.countInstituciones:"No tiene"}</td>
                <td className="text-center">{e.countAulas}</td>


                <td className="text-center">
                 {e.sponsor.nombre}
                </td>

      {/*           <td className="text-center">
                  <Button className="mb-2  " color="warning">
                    Ver Usuarios
                    <span className="badge badge-pill badge-light">
                      {e.alumnos}
                    </span>
                  </Button>
                </td> */}
          
                <td className="text-center">
                  <Button className="mb-2  "onClick={()=>this.deleteSponsor(e)} color="danger">
                    Quitar Premium
                   
                  </Button>
                </td>
            
              </tr>
            );
          })}
            <div>
                          <nav
                            aria-label="Page"
                            className="d-flex w-100 justify-content-center  "
                          >
                            <ul className="pagination">
                              <li
                                className="page-item"
                                onClick={() => this.props.paginate(0)}
                              >
                                <a className="page-link" aria-label="Previous">
                                  <span aria-hidden="true">«</span>
                                  <span className="sr-only">
                                    {" "}
                                    Pagina Anterior
                                  </span>
                                </a>
                              </li>
                              <li className="page-item">
                                <a className="page-link">
                                  {this.props.page } 
                                </a>
                              </li>
                              <li
                                className="page-item"
                                onClick={() => this.props.paginate(1)}
                              >
                                <a className="page-link" aria-label="Next">
                                  <span aria-hidden="true">»</span>
                                  <span className="sr-only">
                                    Proxima Pagina
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/Profesor/component/TableHoverPremium.js